import { render, staticRenderFns } from "./VerifyMobilePage.vue?vue&type=template&id=61140e65&scoped=true&"
import script from "./VerifyMobilePage.vue?vue&type=script&lang=js&"
export * from "./VerifyMobilePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61140e65",
  null
  
)

export default component.exports